import React from 'react'
import { Spin } from 'antd';
import "./Loader.css"

function Loader() {
    return (
        <div className='fixed bg-[#878787a1] w-full h-screen z-50 flex items-center justify-center top-0 right-0 flex-col gap-4'>
            <div class="lds-default"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
            <span className='text-green-800'>لطفا منتظر بمانید...</span>
        </div>
    )
}

export default Loader